var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleframe1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 335,
    viewBox: "0 0 404 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6591_61013)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60.5275 317.59C53.8159 318.511 42.9134 320.194 42.848 322.626C42.7826 324.82 51.5629 326.616 54.6304 327.246C89.7634 334.441 131.911 321.199 178.387 326.408C202.76 329.137 199.086 333.668 220.707 334.804C250.293 336.362 260.869 328.079 297.857 328.507C313.634 328.685 313.907 330.219 335.356 331.444C343.791 331.926 402.875 335.226 403.928 330.184C404.118 329.274 402.697 326.735 377.141 320.527C377.117 320.527 255.126 290.921 60.5275 317.59Z",
    fill: "url(#paint0_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.348 237.749C121.348 237.749 139.425 225.232 151.428 231.476C163.43 237.719 216.046 256.402 217.83 258.347C219.613 260.291 208.568 268.455 208.568 268.455L137.024 249.249L121.348 237.749Z",
    fill: "url(#paint1_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3045 283.636C41.3045 283.636 38.5878 279.028 35.2231 279.509C31.8584 279.991 31.8643 281.888 29.9442 281.888C28.0241 281.888 19.8383 281.888 16.9789 280.925C14.1195 279.961 6.87293 276.602 3.53203 276.602C0.19112 276.602 -0.789731 280.925 0.654824 284.766C2.09938 288.607 6.41521 297.253 14.0957 301.576C21.7762 305.899 35.2231 315.99 37.1432 317.429C39.0633 318.868 43.8666 321.27 48.1884 320.788C52.5102 320.307 52.9917 318.41 52.9917 317.429C52.9917 316.447 53.9547 315.05 54.4303 314.545C54.9059 314.039 57.3135 310.703 57.795 308.301C58.2765 305.899 59.2336 305.423 59.7151 304.941C60.1967 304.46 61.1537 303.502 60.1967 302.057C59.2396 300.613 58.6273 301.606 57.9734 301.112C57.3194 300.618 47.7128 289.57 47.7128 289.57L41.3045 283.636Z",
    fill: "url(#paint2_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9303 284.499C42.7194 283.803 40.4227 283.417 38.1059 283.352C34.7471 283.352 31.8639 284.315 31.3824 288.156C30.9009 291.997 35.2227 299.68 40.5075 302.564C45.7923 305.448 48.188 306.405 51.0712 305.448C53.9544 304.491 57.3131 302.564 57.3131 300.162C57.3131 297.759 44.9303 284.499 44.9303 284.499Z",
    fill: "url(#paint3_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0642 284.098C35.3392 283.551 36.7202 283.295 38.1066 283.349C38.5881 283.349 39.0756 283.349 39.5512 283.414L39.9554 283.349C39.9554 283.349 38.1066 280.465 36.1865 280.465C34.2663 280.465 33.8086 280.946 33.8086 281.428C33.8086 281.91 33.8799 283.884 34.088 284.098H34.0642Z",
    fill: "#A05708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0278 282.867C52.0278 282.867 48.669 284.312 47.2304 284.312C45.7918 284.312 43.8657 284.312 43.3901 285.751C42.9146 287.19 41.9456 295.86 45.3103 298.72C48.675 301.58 52.0277 302.561 54.4294 302.08C56.831 301.598 63.073 298.72 63.073 298.72L52.0278 282.867Z",
    fill: "#F2DAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0705 281.406C50.797 283.839 57.6096 299.245 63.5543 300.619C71.7163 302.539 91.8866 292.936 98.1285 289.089C104.21 285.349 136.543 273.242 137.5 272.761C138.457 272.279 139.426 270.84 139.878 271.797C140.33 272.755 139.878 277.565 143.243 280.443C146.607 283.321 169.173 297.735 172.05 300.619C174.928 303.503 187.923 314.111 192.245 316.489C196.566 318.868 217.694 321.776 229.696 320.337C241.698 318.898 249.866 307.849 249.866 307.849L225.374 264.62C225.374 264.62 216.968 257.836 213.729 256.426C210.489 255.017 205.691 256.932 205.21 258.377C204.728 259.822 203.765 261.736 201.845 260.297C199.925 258.858 157.67 235.323 144.223 231.957C130.777 228.592 113.014 243.487 109.15 245.89C105.286 248.292 66.4137 275.668 63.5305 276.144C60.6473 276.62 51.552 277.107 51.0705 281.406Z",
    fill: "url(#paint4_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.326 144.049C202.326 144.049 203.289 154.158 204.247 155.097C205.204 156.037 206.624 155.579 206.624 158.939C206.624 162.298 207.106 169.987 208.063 170.468C209.02 170.95 212.385 169.029 212.866 169.029C213.348 169.029 218.151 172.871 219.108 174.791C220.065 176.712 223.43 181.992 226.313 182.474C229.196 182.956 233.037 177.194 234.957 178.633C236.877 180.072 237.834 182.956 237.834 184.395C237.834 185.834 260.887 179.114 260.887 170.468C260.887 168.019 254.645 155.097 253.201 152.213C251.756 149.329 249.842 136.848 249.361 133.483C248.879 130.117 243.119 120.514 233.512 117.154C223.906 113.795 201.369 133.013 202.326 144.049Z",
    fill: "#F2DAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.616 113.801C237.954 115.388 247.465 125.331 248.904 130.135C250.342 134.94 253.927 147.379 253.707 149.829C253.225 155.109 244.106 162.316 242.662 159.938C241.217 157.559 236.717 149.395 236.42 146.487C235.938 141.683 233.537 136.884 230.178 136.884C229.221 136.884 226.338 141.207 225.856 143.603C225.262 146.47 228.234 152.249 230.178 153.712C232.122 155.175 237.062 157.981 237.858 160.913C239.303 166.199 236.42 177.247 234.981 178.686C233.542 180.125 229.036 183.205 226.338 182.528C222.497 181.57 220.096 175.802 217.759 173.067C216.779 171.919 214.787 171.004 213.818 169.624C212.849 168.245 224.18 162.863 223.924 159.956C222.961 148.426 219.614 134.607 212.397 135.457C204.235 136.42 203.278 144.103 197.993 145.066C195.122 145.589 183.132 147.445 180.706 132.579C179.945 127.822 192.715 133.055 203.754 125.854C206.667 123.921 218.176 110.441 231.616 113.801Z",
    fill: "#1C2B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.929 162.795C210.221 163.426 207.956 162.01 205.822 159.632C203.688 157.253 202.576 154.815 203.29 154.185C204.003 153.555 206.262 154.97 208.396 157.348C210.53 159.727 211.612 162.165 210.929 162.795Z",
    fill: "#4EE2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.062 157.339C204.437 157.93 204.848 158.498 205.293 159.039L205.828 155.008C205.411 154.697 204.96 154.434 204.485 154.223L204.062 157.339Z",
    fill: "#6CEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.708 155.707L206.113 160C206.399 160.302 206.684 160.587 206.969 160.856L207.564 156.504C207.278 156.218 206.987 155.939 206.708 155.707Z",
    fill: "#6CEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.462 187.769C235.462 185.319 239.303 182.483 241.704 180.081C244.106 177.679 260.43 166.636 260.911 164.716C261.393 162.795 277.235 169.996 282.996 184.404C288.756 198.812 295.48 244.925 278.674 275.667C261.868 306.409 248.428 314.567 247.946 311.689C247.465 308.811 247.946 306.403 242.661 303.525C237.376 300.647 227.294 288.659 224.899 284.313C222.503 279.966 211.452 259.338 212.415 256.96C213.378 254.581 222.978 221.877 227.782 212.292C232.585 202.706 236.907 195.963 236.907 193.079C236.907 190.195 235.462 189.69 235.462 187.769Z",
    fill: "#EF8062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.146 238.683L165.351 231.477L214.33 243.964L222.973 254.054L158.146 238.683Z",
    fill: "url(#paint5_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.583 227.152C183.583 227.152 178.779 231.475 177.822 235.317L181.181 234.359L187.423 231.475L191.745 229.097L189.825 227.176L183.583 227.152Z",
    fill: "#C6B3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.698 226.105C209.698 226.105 204.728 225.713 202.327 224.75C199.925 223.786 197.523 223.311 195.122 223.792C192.72 224.274 187.923 221.872 185.521 222.353C183.12 222.835 174.958 222.353 174.476 222.829C174.14 223.122 173.878 223.49 173.712 223.903C173.546 224.317 173.479 224.764 173.519 225.207C173.519 226.652 175.439 227.128 175.897 227.128C176.354 227.128 185.503 227.61 187.905 228.573C187.905 228.573 183.583 229.049 181.182 231.451C178.78 233.853 174.94 237.219 174.94 237.695C174.94 238.17 174.94 240.073 175.421 240.073H176.378C176.378 240.073 176.86 241.036 177.341 241.036C177.341 241.036 179.719 239.591 180.219 239.591C180.718 239.591 178.78 240.555 179.261 241.518C179.485 241.955 179.826 242.321 180.246 242.575C180.666 242.829 181.148 242.961 181.639 242.957C182.596 242.957 188.363 240.073 190.283 240.579C192.203 241.084 195.562 241.542 197.006 242.499C198.451 243.457 203.248 244.42 204.205 243.938C205.162 243.457 209.698 226.105 209.698 226.105Z",
    fill: "#F2DAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.351 181.51C252.631 182.699 249.867 199.759 250.824 206.484C250.824 206.484 259.949 239.623 256.59 239.623C253.232 239.623 232.58 231.458 229.245 230.501C225.91 229.544 214.383 224.258 212.433 224.258C210.484 224.258 206.191 230.019 204.753 233.861C203.314 237.702 201.394 246.829 203.79 246.829C206.186 246.829 215.317 246.83 217.237 248.269C219.157 249.708 232.098 260.28 239.327 263.134C246.556 265.988 272.457 273.243 276.779 271.78C281.1 270.317 286.885 263.134 286.885 260.256C286.885 257.378 286.403 221.831 283.52 212.686C280.637 203.541 281.558 179.131 262.351 181.51Z",
    fill: "#68A1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.073 238.681L123.578 181.508H133.648C133.808 181.508 133.965 181.547 134.105 181.623C134.245 181.699 134.364 181.808 134.451 181.942L166.38 230.862C166.5 231.042 166.556 231.258 166.537 231.474C166.519 231.69 166.428 231.893 166.279 232.051L160.073 238.681Z",
    fill: "#4EE2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.176 238.665L122.692 183.145C122.591 182.986 122.534 182.803 122.528 182.614C122.522 182.426 122.566 182.239 122.657 182.074C122.747 181.909 122.88 181.771 123.042 181.675C123.204 181.579 123.389 181.528 123.578 181.527L160.072 238.683C159.967 238.839 159.825 238.966 159.659 239.054C159.492 239.142 159.307 239.187 159.119 239.185C158.931 239.183 158.746 239.135 158.582 239.044C158.417 238.953 158.277 238.823 158.176 238.665Z",
    fill: "#1C80FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.526 208.072L142.863 211.735L139.51 189.739L137.186 186.184L140.526 208.072Z",
    fill: "#6CEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.503 214.299L148.266 220.204L144.872 197.947L141.133 192.227L144.503 214.299Z",
    fill: "#6CEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.463 256.356L158.937 242.163C158.717 242.122 158.518 242.006 158.375 241.835C158.232 241.663 158.153 241.447 158.152 241.223V238.66L222.42 253.674C222.579 253.713 222.726 253.791 222.847 253.901C222.968 254.012 223.058 254.151 223.11 254.307C223.162 254.462 223.173 254.628 223.143 254.789C223.113 254.95 223.042 255.1 222.937 255.226L222.343 255.999C222.24 256.13 222.104 256.231 221.95 256.294C221.796 256.356 221.628 256.378 221.463 256.356Z",
    fill: "#1C80FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.147 91.2266H69.1835C66.557 91.2266 64.4277 93.3563 64.4277 95.9836V162.837C64.4277 165.465 66.557 167.594 69.1835 167.594H157.147C159.773 167.594 161.903 165.465 161.903 162.837V95.9836C161.903 93.3563 159.773 91.2266 157.147 91.2266Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.442 96.5156H71.1523V100.839H100.442V96.5156Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.058 106.117H74.7191C72.7493 106.117 71.1523 107.715 71.1523 109.685V145.779C71.1523 147.749 72.7493 149.346 74.7191 149.346H153.058C155.028 149.346 156.625 147.749 156.625 145.779V109.685C156.625 107.715 155.028 106.117 153.058 106.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.173 120.531H75.9551V122.452H119.173V120.531Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.173 126.773H75.9551V128.694H119.173V126.773Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.769 133.02H75.9551V134.94H104.769V133.02Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.032 129.176H140.366C137.411 129.176 135.016 131.572 135.016 134.527V139.195C135.016 142.151 137.411 144.547 140.366 144.547H145.032C147.987 144.547 150.383 142.151 150.383 139.195V134.527C150.383 131.572 147.987 129.176 145.032 129.176Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4689 109H78.4518C77.0729 109 75.9551 110.118 75.9551 111.497V112.746C75.9551 114.125 77.0729 115.244 78.4518 115.244H97.4689C98.8478 115.244 99.9656 114.125 99.9656 112.746V111.497C99.9656 110.118 98.8478 109 97.4689 109Z",
    fill: "#40CD8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.93 7.17578H231.967C229.34 7.17578 227.211 9.30556 227.211 11.9328V78.7865C227.211 81.4137 229.34 83.5435 231.967 83.5435H319.93C322.557 83.5435 324.686 81.4137 324.686 78.7865V11.9328C324.686 9.30556 322.557 7.17578 319.93 7.17578Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.225 12.457H233.936V16.78H263.225V12.457Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.841 22.0664H237.502C235.532 22.0664 233.936 23.6637 233.936 25.6342V61.7279C233.936 63.6983 235.532 65.2957 237.502 65.2957H315.841C317.811 65.2957 319.408 63.6983 319.408 61.7279V25.6342C319.408 23.6637 317.811 22.0664 315.841 22.0664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.95 36.4727H238.732V38.3933H281.95V36.4727Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.95 42.7188H238.732V44.6394H281.95V42.7188Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.546 48.9609H238.732V50.8816H267.546V48.9609Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.246 24.9453H241.229C239.85 24.9453 238.732 26.0634 238.732 27.4427V28.6915C238.732 30.0707 239.85 31.1889 241.229 31.1889H260.246C261.625 31.1889 262.743 30.0707 262.743 28.6915V27.4427C262.743 26.0634 261.625 24.9453 260.246 24.9453Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.658 24.9453H267.641C266.262 24.9453 265.145 26.0634 265.145 27.4427V28.6915C265.145 30.0707 266.262 31.1889 267.641 31.1889H286.658C288.037 31.1889 289.155 30.0707 289.155 28.6915V27.4427C289.155 26.0634 288.037 24.9453 286.658 24.9453Z",
    fill: "#1C80FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.253 0H339.814V2.88393H341.253V0Z",
    fill: "url(#paint6_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.253 123.187H339.814V117.17H341.253V123.187ZM341.253 111.158H339.814V105.141H341.253V111.158ZM341.253 99.1289H339.814V93.1113H341.253V99.1289ZM341.253 87.0937H339.814V81.082H341.253V87.0937ZM341.253 75.0644H339.814V69.0528H341.253V75.0644ZM341.253 63.0352H339.814V57.0176H341.253V63.0352ZM341.253 51.0059H339.814V44.9883H341.253V51.0059ZM341.253 38.9766H339.814V32.959H341.253V38.9766ZM341.253 26.9414H339.814V20.9595H341.253V26.9414ZM341.253 14.9121H339.814V8.89453H341.253V14.9121Z",
    fill: "url(#paint7_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.253 129.207H339.814V132.091H341.253V129.207Z",
    fill: "url(#paint8_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.254 97.5H223.371V98.939H226.254V97.5Z",
    fill: "url(#paint9_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.842 97.5078H237.43V98.9468H231.842V97.5078ZM243.018 97.5078H248.612V98.9468H243.03L243.018 97.5078ZM254.2 97.5078H259.788V98.9468H254.2V97.5078ZM265.376 97.5078H270.97V98.9468H265.376V97.5078ZM276.558 97.5078H282.146V98.9468H276.558V97.5078ZM287.734 97.5078H293.322V98.9468H287.734V97.5078ZM298.916 97.5078H304.504V98.9468H298.91L298.916 97.5078ZM310.092 97.5078H315.679V98.9468H310.092V97.5078ZM321.273 97.5078H326.861V98.9468H321.273V97.5078ZM332.449 97.5078H338.037V98.9468H332.449V97.5078ZM343.625 97.5078H349.219V98.9468H343.625V97.5078ZM354.807 97.5078H360.395V98.9468H354.79L354.807 97.5078Z",
    fill: "url(#paint10_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.868 97.5H365.984V98.939H368.868V97.5Z",
    fill: "url(#paint11_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6222 66.2852H52.1836V69.1691H53.6222V66.2852Z",
    fill: "url(#paint12_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6259 189.473H52.2051V183.455H53.6437L53.6259 189.473ZM53.6259 177.443H52.2051V171.402H53.6437L53.6259 177.443ZM53.6259 165.414H52.2051V159.396H53.6437L53.6259 165.414ZM53.6259 153.379H52.2051V147.367H53.6437L53.6259 153.379ZM53.6259 141.35H52.2051V135.338H53.6437L53.6259 141.35ZM53.6259 129.32H52.2051V123.303H53.6437L53.6259 129.32ZM53.6259 117.291H52.2051V111.273H53.6437L53.6259 117.291ZM53.6259 105.262H52.2051V99.2442H53.6437L53.6259 105.262ZM53.6259 93.2266H52.2051V87.2149H53.6437L53.6259 93.2266ZM53.6259 81.1973H52.2051V75.1797H53.6437L53.6259 81.1973Z",
    fill: "url(#paint13_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6222 195.484H52.1836V198.368H53.6222V195.484Z",
    fill: "url(#paint14_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.071 78.2891H167.188V79.7281H170.071V78.2891Z",
    fill: "url(#paint15_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.589 79.732H156.001V78.293H161.589V79.732ZM150.413 79.732H144.825V78.293H150.413V79.732ZM139.231 79.732H133.649V78.293H139.237L139.231 79.732ZM128.055 79.732H122.467V78.293H128.055V79.732ZM116.873 79.732H111.285V78.293H116.873V79.732ZM105.697 79.732H100.109V78.293H105.709L105.697 79.732ZM94.5209 79.732H88.927V78.293H94.5209V79.732ZM83.339 79.732H77.7688V78.293H83.3568L83.339 79.732ZM72.163 79.732H66.569V78.293H72.163V79.732ZM60.9811 79.732H55.3931V78.293H60.9811V79.732ZM49.8051 79.732H44.2111V78.293H49.8289L49.8051 79.732ZM38.6232 79.732H33.0352V78.293H38.6232V79.732Z",
    fill: "url(#paint16_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4593 78.2891H24.5762V79.7281H27.4593V78.2891Z",
    fill: "url(#paint17_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.346 320.879H317.042C316.454 320.882 315.886 320.668 315.447 320.277C315.008 319.886 314.729 319.346 314.664 318.762L308.939 268.367H361.437L355.712 318.762C355.648 319.344 355.371 319.882 354.934 320.273C354.497 320.664 353.932 320.879 353.346 320.879Z",
    fill: "url(#paint18_linear_6591_61013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.191 271.947C349.69 271.947 361.443 270.61 361.443 268.962C361.443 267.313 349.69 265.977 335.191 265.977C320.693 265.977 308.939 267.313 308.939 268.962C308.939 270.61 320.693 271.947 335.191 271.947Z",
    fill: "#1C2B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.794 171.69C318.479 172.879 323.246 215.853 323.246 215.853C326.813 252.851 331.569 269.56 335.183 270.749C338.798 271.938 345.919 218.237 345.919 205.108C345.931 205.108 347.126 170.501 332.794 171.69Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.579 264.785H334.507C334.43 264.775 334.354 264.75 334.286 264.712C334.218 264.673 334.158 264.621 334.11 264.559C334.062 264.497 334.027 264.426 334.006 264.351C333.986 264.275 333.98 264.196 333.99 264.119C338.698 225.26 332.855 176.435 332.801 175.948C332.782 175.79 332.827 175.631 332.925 175.506C333.023 175.381 333.167 175.301 333.324 175.282C333.482 175.263 333.641 175.307 333.765 175.405C333.89 175.503 333.971 175.647 333.99 175.805C334.05 176.292 339.935 225.26 335.179 264.261C335.161 264.407 335.09 264.542 334.979 264.638C334.868 264.735 334.726 264.787 334.579 264.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.856 151.402C288.667 157.348 295.8 158.567 296.989 166.921C298.178 175.276 294.612 177.66 295.8 182.435C296.989 187.21 304.123 188.381 305.348 200.333C306.572 212.285 301.781 211.078 302.97 218.237C304.159 225.397 311.322 225.373 312.517 231.367C313.712 237.361 313.706 245.685 316.084 252.851C318.462 260.016 325.631 270.749 329.209 270.749C332.788 270.749 342.335 250.46 339.946 244.496C337.556 238.532 334.001 237.361 334.001 232.562C334.001 227.763 338.757 215.853 337.568 207.499C336.379 199.144 325.661 195.564 324.472 189.594C323.283 183.624 326.849 168.111 318.527 160.951C310.204 153.792 291.045 145.437 289.856 151.402Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.203 164.533C407.423 168.754 393.655 170.479 392.467 178.857C391.278 187.235 391.278 190.791 386.522 195.566C381.766 200.341 374.591 201.512 375.786 208.69C376.981 215.867 379.353 223.014 375.786 226.594C372.219 230.173 363.855 230.161 361.465 236.143C359.075 242.125 360.276 249.267 355.52 255.237C350.765 261.207 343.589 273.141 337.621 270.751C331.652 268.36 335.243 240.918 337.621 236.143C339.999 231.369 342.377 227.819 342.377 224.209C342.377 220.6 341.188 214.66 343.566 208.69C345.943 202.719 359.075 200.335 360.264 196.755C361.453 193.176 362.642 174.082 369.811 169.307C376.981 164.533 396.045 157.373 403.203 164.533Z",
    fill: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.429 268.707C339.323 268.705 339.218 268.676 339.126 268.623C339.058 268.584 338.999 268.531 338.951 268.468C338.904 268.405 338.87 268.333 338.85 268.257C338.831 268.18 338.827 268.101 338.838 268.023C338.85 267.945 338.877 267.87 338.918 267.803C338.965 267.72 343.745 259.734 344.755 255.69C345.017 254.65 345.35 253.074 345.695 251.249C347.014 244.624 349.006 234.599 352.073 231.543C356.526 227.089 363.642 213.454 368.623 195.996C374.764 174.494 395.071 168.203 395.279 168.138C395.431 168.093 395.595 168.11 395.735 168.186C395.874 168.262 395.977 168.39 396.022 168.542C396.067 168.694 396.05 168.858 395.974 168.998C395.898 169.137 395.77 169.24 395.618 169.285C395.422 169.345 375.733 175.464 369.771 196.323C364.73 213.971 357.477 227.838 352.917 232.387C350.106 235.2 348.079 245.391 346.866 251.48C346.497 253.324 346.182 254.911 345.915 255.982C344.862 260.192 340.142 268.082 339.97 268.415C339.915 268.509 339.835 268.585 339.74 268.636C339.645 268.688 339.537 268.712 339.429 268.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.162 266.096C329.004 266.096 328.853 266.033 328.741 265.922C328.63 265.81 328.567 265.659 328.567 265.501C328.567 265.341 328.466 249.833 323.924 245.284C319.383 240.735 316.684 226.565 315.4 199.54C314.211 174.982 296.632 154.758 296.454 154.556C296.402 154.497 296.362 154.429 296.337 154.354C296.311 154.28 296.301 154.201 296.306 154.123C296.311 154.044 296.331 153.968 296.366 153.897C296.4 153.827 296.449 153.764 296.507 153.712C296.566 153.66 296.635 153.62 296.709 153.595C296.784 153.569 296.862 153.559 296.941 153.564C297.019 153.569 297.096 153.589 297.166 153.624C297.237 153.658 297.3 153.706 297.352 153.765C297.53 153.967 315.4 174.5 316.589 199.48C317.843 225.828 320.441 240.117 324.768 244.44C329.655 249.334 329.762 264.829 329.762 265.489C329.762 265.647 329.699 265.798 329.588 265.91C329.476 266.021 329.325 266.084 329.168 266.084L329.162 266.096Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6591_61013",
    x1: 403.922,
    y1: 320.717,
    x2: 93.7641,
    y2: 320.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A869B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6591_61013",
    x1: 93266.7,
    y1: 20370.1,
    x2: 94283.7,
    y2: 23733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A869B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6591_61013",
    x1: 0.000906074,
    y1: 298.751,
    x2: 60.6068,
    y2: 298.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6591_61013",
    x1: 21138.9,
    y1: 15386.9,
    x2: 20440.9,
    y2: 15940.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A869B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6591_61013",
    x1: 164018,
    y1: 57717,
    x2: 247528,
    y2: 57717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A869B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6591_61013",
    x1: 159.882,
    y1: 234.616,
    x2: 200.414,
    y2: 244.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C80FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6591_61013",
    x1: 340.534,
    y1: 136.883,
    x2: 340.534,
    y2: 39.4534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6591_61013",
    x1: 1107.85,
    y1: 45271.5,
    x2: 1107.85,
    y2: 26544.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6591_61013",
    x1: 322.58,
    y1: 1271.1,
    x2: 322.58,
    y2: 798.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6591_61013",
    x1: 761.634,
    y1: -298.231,
    x2: 580.829,
    y2: -298.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6591_61013",
    x1: 33848.2,
    y1: -405.118,
    x2: 25786.6,
    y2: -405.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6591_61013",
    x1: 619.015,
    y1: -298.231,
    x2: 438.213,
    y2: -298.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6591_61013",
    x1: 180.206,
    y1: 1051.61,
    x2: 180.206,
    y2: 579.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6591_61013",
    x1: 1239.31,
    y1: 59669.8,
    x2: 1239.31,
    y2: 40942.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6591_61013",
    x1: 180.206,
    y1: 1180.81,
    x2: 180.206,
    y2: 708.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6591_61013",
    x1: 259.968,
    y1: 269.502,
    x2: 440.8,
    y2: 269.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6591_61013",
    x1: 98809.7,
    y1: 528.164,
    x2: 106871,
    y2: 528.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6591_61013",
    x1: 117.356,
    y1: 269.502,
    x2: 298.189,
    y2: 269.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6591_61013",
    x1: 70104.3,
    y1: 35727.2,
    x2: 62584.1,
    y2: 35714.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A869B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6591_61013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 404,
    height: 335,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleframe1);
export default __webpack_public_path__ + "static/media/googleframe1.1f1106ebe57e4b77184b740b0ad59f68.svg";
export { ForwardRef as ReactComponent };